import { render, staticRenderFns } from "./x-errors-messages.vue?vue&type=template&id=443bb17a&scoped=true&"
import script from "./x-errors-messages.vue?vue&type=script&lang=js&"
export * from "./x-errors-messages.vue?vue&type=script&lang=js&"
import style0 from "./x-errors-messages.vue?vue&type=style&index=0&id=443bb17a&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443bb17a",
  null
  
)

export default component.exports